import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './modules/shared/submodule-material.module';
import { SharedModule } from './modules/shared/shared.module';
import { AdminSideMenuComponent } from './components/admin-side-menu/admin-side-menu.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslateModule } from '@ngx-translate/core';
import { TopMenuComponent } from './components/top-menu/top-menu.component';
import { AccountSelectComponent } from './components/account-select/account-select.component';
import { ActiveMenuItemDirective } from './components/active-menu-item.directive';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { SailAssistantComponent } from './components/sail-assistant/sail-assistant.component';
import { matIconsRegistry } from './mat-icons-registry';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MERMAID_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { MERMAID_CONFIG } from './modules/standalone/components/md-viewer/md-viewer.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    AdminSideMenuComponent,
    TopMenuComponent,
    AccountSelectComponent,
    ActiveMenuItemDirective,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoadingBarHttpClientModule,
    MaterialModule,
    SailAssistantComponent,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
  ],
  providers: [
    provideMarkdown({
      mermaidOptions: {
        provide: MERMAID_OPTIONS,
        useValue: MERMAID_CONFIG,
      },
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // supposed to use it for sentry in angular 19, but it doesn't work
    // provideAppInitializer(() => inject(Sentry.TraceService)),
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [TopMenuComponent],
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconsRegistry(matIconRegistry, domSanitizer);
  }
}
